import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import { _get } from "../Api";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { enGB } from "react-date-range/dist/locale";
import ViewDeliveryCosts from "../components/ReportingViews/ViewDeliveryCosts";
import ViewPaymentCosts from "../components/ReportingViews/ViewPaymentCosts";
import ViewReceiptTypes from "../components/ReportingViews/ViewReceiptTypes";
import ViewArticles from "../components/ReportingViews/ViewArticles";
import ViewVats from "../components/ReportingViews/ViewVats";
import AuthorizationWrapper from "../components/AuthorizationWrapper";
import { Table as TablePDF } from "@david.kucsai/react-pdf-table/lib/Table";
import { TableHeader as TableHeaderPDF } from "@david.kucsai/react-pdf-table/lib/TableHeader";
import { TableCell as TableCellPDF } from "@david.kucsai/react-pdf-table/lib/TableCell";
import { TableBody as TableBodyPDF } from "@david.kucsai/react-pdf-table/lib/TableBody";
import { format } from "date-fns";
import PdfGenerator from "../components/TablePdf/PdfGenerator";
import TextField from "@material-ui/core/TextField";
import { toast, ToastContainer } from "react-toastify";
import DataProcessorFilter from "../components/TakeawayDeliveryReporting/DataProcessorFilter";
import cloudStore from "../store/CloudStore";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { useParams } from "react-router-dom";
import { useDialog } from "../components/Dialogs/DialogProvider";
import RowExport from "../components/TakeawayDeliveryReporting/RowExport";
import ViewPaymentMethodsTakeaway from "../components/ReportingViews/ViewPaymentMethodsTakeaway";

Date.formatted = function () {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();

  return [this.getFullYear(), (mm > 9 ? "" : "0") + mm, (dd > 9 ? "" : "0") + dd].join("-");
};

Array.naturalSort = function (arr, property) {
  var a,
    b,
    a1,
    b1,
    rx = /(\d+)|(\D+)/g,
    rd = /\d+/;
  return arr.sort(function (as, bs) {
    as = as[property];
    bs = bs[property];
    a = String(as).toLowerCase().match(rx);
    b = String(bs).toLowerCase().match(rx);
    while (a.length && b.length) {
      a1 = a.shift();
      b1 = b.shift();
      if (rd.test(a1) || rd.test(b1)) {
        if (!rd.test(a1)) return 1;
        if (!rd.test(b1)) return -1;
        if (a1 != b1) return a1 - b1;
      } else if (a1 != b1) return a1 > b1 ? 1 : -1;
    }
    return a.length - b.length;
  });
};

Date.addDays = function (days) {
  let date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

const fetchData = (taMerchantId, start, end) => {
  let url = "/nova/ta_merchant/" + taMerchantId + "/reporting/day";
  if (start && end) {
    url +=
      "?fromdate=" +
      start.getFullYear() +
      "-" +
      (start.getMonth() + 1) +
      "-" +
      start.getDate() +
      "&todate=" +
      end.getFullYear() +
      "-" +
      (end.getMonth() + 1) +
      "-" +
      end.getDate();
  } else if (start) {
    url += "?fromdate=" + start.getFullYear() + "-" + (start.getMonth() + 1) + "-" + start.getDate();
  } else if (end) {
    url += "?todate=" + end.getFullYear() + "-" + (end.getMonth() + 1) + "-" + end.getDate();
  }

  return _get(url)
    .then((res) => {
      if (!res.data) {
        return Promise.resolve(null);
      } else if (res.data.length === 0) {
        return Promise.resolve([]);
      } else {
        let data = res.data.map((row) => {
          if(row.contact_information) {
            row.contactInfo = JSON.parse(row.contact_information);
          }
          return row;
        });
        return Promise.resolve(data);
      }
    })
    .catch((e) => {
      return Promise.reject(null);
    });
};

export default function TakeawayDeliveryReporting() {
  const [range, setRange] = React.useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [rawData, setRawData] = React.useState(null);
  const [data, setData] = React.useState(null);
  const [fetching, setFetching] = React.useState(true);
  const [email, setEmail] = React.useState(
    localStorage.getItem("defaultEmailReporting") ? localStorage.getItem("defaultEmailReporting") : ""
  );
  const [qrCodeFilter, setQrCodeFilter] = React.useState([]);
  const paramTaMerchantId = Number.parseInt(useParams().taMerchantId);
  const [taMerchant, setTaMerchant] = React.useState(
    cloudStore.merchant.ta_merchants.find((taMerchant) => taMerchant.id === paramTaMerchantId)
  );

  const [taMerchantIds, setTaMerchantIds] = React.useState(
    paramTaMerchantId ? [paramTaMerchantId] : cloudStore.merchant.ta_merchants.map((taMerchant) => taMerchant.id)
  );
  const [openDialog] = useDialog();

  useEffect(() => {
    let data = null;
    if (rawData != null) {
      data = DataProcessorFilter(rawData, qrCodeFilter);
    }
    setData(data);
  }, [rawData]);

  if (
    !taMerchantIds.equals(
      paramTaMerchantId ? [paramTaMerchantId] : cloudStore.merchant.ta_merchants.map((taMerchant) => taMerchant.id)
    )
  ) {
    setTaMerchantIds(
      paramTaMerchantId ? [paramTaMerchantId] : cloudStore.merchant.ta_merchants.map((taMerchant) => taMerchant.id)
    );
    setRawData(null);
    setFetching(true);
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const fetchWithDates = (start, end) => {
    let dataTaMerchantIds = taMerchantIds.map((taMerchantId, index) => {
      return { loaded: false, data: null };
    });
    taMerchantIds.forEach((taMerchantId, index) => {
      fetchData(taMerchantId, start, end)
        .then((data) => {
          dataTaMerchantIds[index].data = data;
          dataTaMerchantIds[index].loaded = true;

          if (dataTaMerchantIds.some((item) => !item.loaded)) {
            return;
          }
          setRawData(
            dataTaMerchantIds.reduce((dataSets, item) => {
              if (item.data != null) {
                dataSets = dataSets.concat(item.data);
              }
              return dataSets;
            }, [])
          );
          setFetching(false);
        })
        .catch(() => {
          dataTaMerchantIds[index].data = null;
          dataTaMerchantIds[index].loaded = true;
          if (dataTaMerchantIds.some((item) => !item.loaded)) {
            return;
          }
          setRawData(
            dataTaMerchantIds.reduce((dataSets, item) => {
              if (item.data != null) {
                dataSets = dataSets.concat(item.data);
              }
              return dataSets;
            }, [])
          );
          setFetching(false);
        });
    });
  };

  if (rawData === null) {
    fetchWithDates(range.startDate, range.endDate);
  }

  let viewRangeInput = (
    <TablePDF data={[0]}>
      <TableHeaderPDF>
        <TableCellPDF weighting={0.3}>Reporting Takeaway/Delivery</TableCellPDF>
        <TableCellPDF weighting={0.3} align={"right"}>
          From
        </TableCellPDF>
        <TableCellPDF weighting={0.3} align={"right"}>
          Until
        </TableCellPDF>
      </TableHeaderPDF>
      <TableBodyPDF>
        <TableCellPDF weighting={0.3}></TableCellPDF>
        <TableCellPDF weighting={0.3}>{format(range.startDate, "MMM d, yyyy")}</TableCellPDF>
        <TableCellPDF weighting={0.3} align={"right"}>
          {format(range.endDate, "MMM d, yyyy")}
        </TableCellPDF>
      </TableBodyPDF>
    </TablePDF>
  );
  let viewReceiptTypesPdf = null;
  let viewPaymentMethodsPdf = null;
  let viewPaymentCostsPdf = null;
  let viewVatsPdf = null;
  let viewDeliveryCostsPdf = null;
  let viewArticlesPdf = null;

  return (
    <div style={{ display: "flex", flexFlow: "wrap" }}>
      <div style={{ display: "flex" }}>
        <DateRangePicker
          locale={enGB}
          weekStartsOn={1}
          maxDate={new Date()}
          ranges={[range]}
          onChange={(newRange) => {
            if (newRange.selection.startDate !== range.startDate || newRange.selection.endDate !== range.endDate) {
              setFetching(true);
              setRange({
                key: "selection",
                startDate: newRange.selection.startDate,
                endDate: newRange.selection.endDate,
              });

              fetchWithDates(newRange.selection.startDate, newRange.selection.endDate);
            }
          }}
        />
        <div style={{ display: "flex", flexDirection: "column", margin: "8px" }}>
          {taMerchant && (
            <>
              <InputLabel id="demo-simple-select-label">QR-Code</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={qrCodeFilter}
                onChange={(event) => {
                  setQrCodeFilter(event.target.value);
                }}
                multiple
              >
                {Array.naturalSort(taMerchant.sp_qr_codes, "table_id").map((spQrCode) => {
                  return (
                    <MenuItem value={spQrCode.identifier} key={spQrCode.identifier}>
                      {spQrCode.table_id} {spQrCode.identifier}
                    </MenuItem>
                  );
                })}
              </Select>
            </>
          )}

          {!(data === null || fetching) ? (
            <>
              <Button
                style={{ margin: "8px" }}
                variant={"outlined"}
                onClick={() => {
                  PdfGenerator(
                    [
                      viewRangeInput,
                      viewReceiptTypesPdf,
                      viewPaymentMethodsPdf,
                      viewVatsPdf,
                      viewArticlesPdf,
                      viewDeliveryCostsPdf,
                      viewPaymentCostsPdf,
                    ],
                    "",
                    true
                  );
                }}
              >
                Download PDF
              </Button>
              <TextField
                style={{ margin: "8px" }}
                label={"E-mail address"}
                variant={"outlined"}
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
              />
              <Button
                style={{ margin: "8px" }}
                variant={"outlined"}
                onClick={() => {
                  localStorage.setItem("defaultEmailReporting", email);
                  PdfGenerator(
                    [
                      viewRangeInput,
                      viewReceiptTypesPdf,
                      viewPaymentMethodsPdf,
                      viewVatsPdf,
                      viewArticlesPdf,
                      viewDeliveryCostsPdf,
                      viewPaymentCostsPdf,
                    ],
                    email,
                    false
                  );
                  toast.success("Verzonden!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }}
              >
                Send PDF
              </Button>
              <Button
                style={{ margin: "8px" }}
                variant={"outlined"}
                onClick={() => {
                  openDialog({ children: <RowExport rows={rawData} /> });
                }}
              >
                Export Orders as Excel
              </Button>
            </>
          ) : null}
        </div>
      </div>

      {data === null || fetching ? (
        <div align="center">
          <CircularProgress color="primary" />
        </div>
      ) : (
        <>
          <div style={{ padding: "10px", width: "100%" }}>
            <ViewReceiptTypes
              receiptTypes={data.receiptTypes}
              createPdf={(view) => {
                viewReceiptTypesPdf = view;
              }}
            />
          </div>
          <div style={{ padding: "10px", width: "100%" }}>
            <ViewPaymentMethodsTakeaway
              payments={data.payments}
              createPdf={(view) => {
                viewPaymentMethodsPdf = view;
              }}
            />
          </div>
          <AuthorizationWrapper
            permission={"vat"}
            child={
              <div style={{ padding: "10px", width: "100%" }}>
                <ViewVats
                  vats={data.totalVats}
                  createPdf={(view) => {
                    viewVatsPdf = view;
                  }}
                />
              </div>
            }
          />
          <div style={{ padding: "10px", width: "100%" }}>
            <ViewArticles
              articleLevel={data.articleLevel}
              createPdf={(view) => {
                viewArticlesPdf = view;
              }}
            />
          </div>
          <div style={{ padding: "10px", width: "100%" }}>
            <ViewDeliveryCosts
              deliveries={data.deliveries}
              createPdf={(view) => {
                viewDeliveryCostsPdf = view;
              }}
            />
          </div>
          <div style={{ padding: "10px", width: "100%" }}>
            <ViewPaymentCosts
              paymentCosts={data.paymentCosts}
              createPdf={(view) => {
                viewPaymentCostsPdf = view;
              }}
            />
          </div>
        </>
      )}
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
